var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1753 0.394423C19.842 -0.00424693 19.2753 -0.103914 18.842 0.195088L16.9086 1.52399C16.0086 0.560536 14.742 0.0289756 13.3753 0.0289756C10.6753 0.0289756 8.44198 2.22166 8.44198 4.94591C8.44198 5.34458 8.47532 5.71002 8.57532 6.07547C6.24198 5.57713 4.84198 3.88279 4.30865 0.826316C4.24198 0.427646 3.94198 0.128643 3.54198 0.0289756C3.17532 -0.070692 2.77532 0.0954206 2.54198 0.394423C2.47532 0.460868 -3.02468 8.10205 4.94198 14.5804C4.17532 16.2083 1.87532 17.6037 0.975315 18.0688C0.541982 18.2681 0.341982 18.7332 0.441982 19.1984C0.541982 19.6635 0.941982 19.9625 1.40865 19.9625H3.14198C13.2753 19.9625 17.8753 14.9459 17.9753 3.71667L20.0753 1.72332C20.4753 1.3911 20.5086 0.793093 20.1753 0.394423Z",
    fill: "#64ffda"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e7874fa4d8879a83aadd6aabcc28dc7e.svg";
export { ForwardRef as ReactComponent };